<script setup lang="ts">
const appConfig = useAppConfig();
const { oneLink } = useAppConfig();
</script>

<template>
  <div class="cta bg-[url('~/assets/img/cta_bg-min.jpg')] overflow-hidden bg-cover bg-center p-5 rounded-xl relative max-md:p-4">
    <div class="flex items-center justify-between max-md:justify-center max-md:flex-col-reverse">
      <div class="md:pl-[10%]">
        <p class="max-w-[520px] max-lg:max-w-[450px] text-white text-4xl max-lg:text-3xl max-md:text-2xl font-bold mb-6 max-md:text-center max-md:px-4">
          Dive into FictionMe's diverse book reviews!
        </p>
        <a
            :href="oneLink.baseUrl"
            class="flex items-center py-2 px-5 max-md:px-4 bg-fm-gradient hover:bg-fm-gradient-active rounded-lg !text-white text-lg w-max max-md:m-auto"
        >
          Read books in the App
        </a>
      </div>
      <div class="lg:pr-[7%] max-lg:w-[212px] max-md:mb-3">
        <nuxt-img
            src="/img/reviews_cta_img.webp"
            width="277"
            height="277"
            :quality="80"
            format="webp"
            alt="Romantic couple"
        />
      </div>
    </div>
  </div>
</template>

<style scoped>

</style>